import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ice-cream"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 15L8.99997 7L2.98477 19.7021C2.62917 20.5319 3.46811 21.3708 4.29783 21.0152L17 15Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.9998 4C13.634 2.63412 11.3657 2.63412 9.99983 4C9.19126 4.80857 8.85109 5.93337 8.99983 7L16.9998 15C18.0665 15.1487 19.1913 14.8086 19.9998 14C21.3657 12.6341 21.3657 10.3659 19.9998 9.00001C21.3657 7.63412 21.3657 5.36588 19.9998 4C18.634 2.63412 16.3657 2.63412 14.9998 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 15L8.99997 7L2.98477 19.7021C2.62917 20.5319 3.46811 21.3708 4.29783 21.0152L17 15Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14.9998 4C13.634 2.63412 11.3657 2.63412 9.99983 4C9.19126 4.80857 8.85109 5.93337 8.99983 7L16.9998 15C18.0665 15.1487 19.1913 14.8086 19.9998 14C21.3657 12.6341 21.3657 10.3659 19.9998 9.00001C21.3657 7.63412 21.3657 5.36588 19.9998 4C18.634 2.63412 16.3657 2.63412 14.9998 4Z","strokeWidth":"props.strokeWidth"}}]}]};

const IceCream = Vue.extend<IconProps>({
  name: 'IceCreamIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ice-cream',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default IceCream;
